import { useFormats } from "@ryde/shared";

import { CsvCellTransformerFn, ICsvColumnTransformer } from "./models";

export const useCsvDateCellTransformer = (): {
  getDateValue: CsvCellTransformerFn;
} => {
  const { getLocaleTimeFromUTCTimeForCSV } = useFormats();

  const getDateValue = ({ value }: ICsvColumnTransformer): string => {
    return getLocaleTimeFromUTCTimeForCSV(value);
  };

  return { getDateValue };
};
